import React from 'react';
import Label from 'components/_utility/Label';
import { Wrap, Input, Check, Label as RadioLabel } from './Radio.styled';

const Radio = ({ id, label, isWhite, ...props }) => (
  <Wrap>
    <Input id={id} type="radio" {...props} />
    <RadioLabel htmlFor={id} isWhite={isWhite}>
      <Label name={label} />
    </RadioLabel>
    <Check isWhite={isWhite} />
  </Wrap>
);

export default Radio;
